import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || '';

const api = axios.create({
  baseURL: `${API_URL}/api`,
  timeout: 30000,
});

// أضف الـ access token لكل طلب
api.interceptors.request.use(config => {
  if (!navigator.onLine) {
    return Promise.reject({ userMessage: 'تعذر الاتصال — تأكد من اتصالك بالشبكه' });
  }
  const token = localStorage.getItem('token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// متغير لمنع محاولات تجديد متعددة في نفس الوقت
let isRefreshing = false;
let pendingQueue = []; // طلبات معلقة تنتظر تجديد التوكن

function processPendingQueue(error, token = null) {
  pendingQueue.forEach(p => error ? p.reject(error) : p.resolve(token));
  pendingQueue = [];
}

api.interceptors.response.use(
  res => res,
  async err => {
    const url            = err.config?.url || '';
    const isAuthEndpoint = url.includes('/auth/login') || url.includes('/auth/register') || url.includes('/auth/refresh');
    const originalReq    = err.config;

    if (!err.response) {
      err.userMessage = 'تعذر الاتصال — تأكد من اتصالك بالوايفاي';
      return Promise.reject(err);
    }

    // ── تجديد تلقائي للـ access token عند انتهاء صلاحيته ──────────────────
    if (err.response?.status === 401 && !isAuthEndpoint && !originalReq._retried) {
      const refreshToken = localStorage.getItem('refreshToken');

      // لا يوجد refresh token → تسجيل خروج فوري
      if (!refreshToken) {
        localStorage.removeItem('token');
        localStorage.removeItem('refreshToken');
        localStorage.removeItem('user');
        window.location.href = '/login';
        return Promise.reject(err);
      }

      // لو في تجديد جارٍ → أضف الطلب للقائمة المنتظرة
      if (isRefreshing) {
        return new Promise((resolve, reject) => {
          pendingQueue.push({
            resolve: (token) => { originalReq.headers.Authorization = `Bearer ${token}`; resolve(api(originalReq)); },
            reject,
          });
        });
      }

      originalReq._retried = true;
      isRefreshing = true;

      try {
        const { data } = await axios.post(`${API_URL}/api/auth/refresh`, { refreshToken });
        localStorage.setItem('token', data.token);
        localStorage.setItem('refreshToken', data.refreshToken);
        api.defaults.headers.common['Authorization'] = `Bearer ${data.token}`;
        processPendingQueue(null, data.token);
        originalReq.headers.Authorization = `Bearer ${data.token}`;
        return api(originalReq); // أعد إرسال الطلب الأصلي بالتوكن الجديد
      } catch (refreshErr) {
        processPendingQueue(refreshErr);
        // نسجّل خروج فقط لو الرفض كان صريحاً من السيرفر (401 = توكن التجديد
        // نفسه غير صالح). أي خطأ آخر (انقطاع شبكة، مهلة، خطأ سيرفر مؤقت 500)
        // لا يعني إن الجلسة انتهت فعلاً — نُبقي المستخدم مسجّلاً دخوله ونكتفي
        // بفشل هذا الطلب، يقدر يعيد المحاولة لاحقاً بدون ما يفقد جلسته.
        if (refreshErr.response?.status === 401) {
          localStorage.removeItem('token');
          localStorage.removeItem('refreshToken');
          localStorage.removeItem('user');
          window.location.href = '/login';
        }
        return Promise.reject(refreshErr);
      } finally {
        isRefreshing = false;
      }
    }

    return Promise.reject(err);
  }
);

export default api;
